import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

import placeholder from "./-assets/placeholder-people.png";

export const Route = createFileRoute(
  "/_staff/places/_layout/_placeholders/people",
)({
  component: () => <ComingSoonCover placeholderImage={placeholder} />,
});
